import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "width", "height"];
import React from 'react';

var Tu = function Tu(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1em' : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? '1em' : _ref$height,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: className,
    width: width,
    height: height
  }, props, {
    viewBox: "0 0 158.3 129",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M107.3,22.5H66.8v105H41.3v-105H0V0h107.3V22.5z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M84,55.5h24v39c0,0,1.8,7.5,9.8,10.5c2.5,0.9,6,0,6,0s6.1-0.7,9.8-11.3c-0.2-10,0-30.8,0-30.8s1.1-6.3,6.8-6.8c5.7-0.4,7.5-1.5,7.5-1.5c0,0,8-4.9,9.8-6.8c0.2-0.2,0,47.3,0,47.3s-5.3,30.1-30.8,33c-4.2,0.3-10.5,0-10.5,0s-27.9-1.9-32.3-33C84,61.2,84,55.5,84,55.5"
  }));
};

Tu.displayName = 'TuLogo';
export default Tu;